// src/features/editor/components/EditorHeader/UndoRedoButtons.tsx
import { Undo2, Redo2 } from 'lucide-react'
import { useBlockHistory } from '@/features/editor/components/studio/BlockDraftContext'
import { TooltipIconButton } from './TooltipIconButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Undo/Redo правки ОТКРЫТОГО блока (п.11). Подсказка называет область прямо:
 * кнопки в шапке читаются как глобальные и иначе обещали бы отмену удаления
 * урока или блока, которой нет.
 *
 * Обе кнопки меняют только черновик — на сервер ничего не уходит, сохранение
 * остаётся за кнопкой «Сохранить».
 */
export const UndoRedoButtons = () => {
  const { canUndo, canRedo, undo, redo } = useBlockHistory()
  const m = useMessages(messages)
  return (
    <>
      <TooltipIconButton icon={Undo2} ariaLabel={m.undo} onClick={undo} disabled={!canUndo} />
      <TooltipIconButton icon={Redo2} ariaLabel={m.redo} onClick={redo} disabled={!canRedo} />
    </>
  )
}
